import { Text } from '@viapeople/components'
import { FeatureFlagDemo } from '../../components/FeatureFlagDemo'
import { DashboardPageTable } from './DashboardPageTable'

export function DashboardPage() {
	return (
		<main className='w-full p-6'>
			<div className='mb-6'>
				<Text variant='h3' weight='semibold'>
					Dashboard
				</Text>
			</div>

			<FeatureFlagDemo />

			<div>
				<DashboardPageTable />
			</div>
		</main>
	)
}
